module.exports = __webpack_public_path__ + "static/videoposter-0cfaf281aea9cc3230270e243f26b3c0.jpg";